module.exports = {
  POSITIONING_COMPLETE_EVENT: "positionComplete",
  REPOSITIONING_DELAY: 200
};